/* AUTAVEX — логіка органайзерів */
(function(){
var D=window.AVO;if(!D)return;
var C=D.CDN;
var EMBP=(window.AV_P_ORG&&window.AV_P_ORG.emb)?window.AV_P_ORG.emb:(D.EMB||550);
var V={
 c:[46337866072200,46337868300424,46337868333192,46337868365960,46337868398728],
 p:[46337868431496,46337868464264,46337868497032,46337868529800,46337868562568],
 lin:46337868595336, emb:46337868628104, logo:46337868660872
};
var CATS=[['Comfort','\u0442\u0443\u0440\u0435\u0446\u044c\u043a\u0430 \u0435\u043a\u043e\u0448\u043a\u0456\u0440\u0430'],['Premium','\u043d\u0456\u043c\u0435\u0446\u044c\u043a\u0430, \u0440\u0443\u0447\u043d\u0430 \u043f\u0440\u043e\u0448\u0438\u0432\u043a\u0430']];
var st={cat:0,g:0,size:0,mat:0,mat2:4,lin:0,edge:0,dz:0,stitch:0,thr:0,emb:0,logo:false,files:[]};
function Q(i){return document.getElementById(i)}
function px(u,w){return C+u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
function money(v){return Math.round(v).toLocaleString('uk-UA')+' \u20b4'}
function shade(h){var r=parseInt(h.substr(1,2),16),g=parseInt(h.substr(3,2),16),b=parseInt(h.substr(5,2),16);
 r=Math.round(r*.62);g=Math.round(g*.62);b=Math.round(b*.62);
 return '#'+[r,g,b].map(function(v){return ('0'+v.toString(16)).slice(-2)}).join('')}
function stars(v){var f=Math.floor(v),h=(v-f)>=0.4,o='';for(var i=0;i<f;i++)o+='\u2605';if(h)o+='<span style="opacity:.45">\u2605</span>';for(var j=f+(h?1:0);j<5;j++)o+='\u2606';return o}
function prem(){return st.cat===1}
function vector(){return prem()&&D.DZ[st.dz][0]==='\u0412\u0435\u043a\u0442\u043e\u0440'}
function base(){return D.SIZE[st.size][1]+(prem()?D.PREM:0)}
function total(){
  var s=base();
  if(!prem()&&st.lin>0)s+=D.LINPLUS;
  if(st.emb>0)s+=EMBP;
  if(st.logo)s+=D.LOGO;
  return s;
}
function dotsHTML(arr,key,sel,thr){
  return arr.map(function(c,i){
    var bg=thr
      ? (c[2]?'linear-gradient(135deg,'+c[1]+' 0%,#FFFFFF 38%,'+c[1]+' 62%,'+shade(c[1])+' 100%)':c[1])
      : (c[2]?c[1]+' url('+px(c[2],96)+') center/cover':c[1]);
    return '<button type="button" class="'+(sel===i?'on':'')+'" title="'+c[0]+'" data-'+key+'="'+i+'" style="background:'+bg+'"></button>'}).join('');
}
function build(){
  Q('ogCats').innerHTML=CATS.map(function(c,i){return '<button type="button" class="'+(i===st.cat?'on':'')+'" data-cat="'+i+'"><b>\u041e\u0440\u0433\u0430\u043d\u0430\u0439\u0437\u0435\u0440\u0438 '+c[0]+'</b><span>'+c[1]+'</span></button>'}).join('');
  var G=(prem()?D.GAL_P:D.GAL_C);
  if(st.g>=G.length)st.g=0;
  Q('ogStage').innerHTML='<img src="'+px(G[st.g],900)+'" alt="" loading="lazy" decoding="async">';
  Q('ogThumbs').innerHTML=G.map(function(u,i){return '<button type="button" class="'+(i===st.g?'on':'')+'" data-g="'+i+'"><img src="'+px(u,160)+'" alt="" loading="lazy" decoding="async"></button>'}).join('');
  Q('ogDzWrap').style.display=prem()?'block':'none';
  if(prem()){
    Q('ogDz').innerHTML=D.DZ.map(function(d,i){return '<button type="button" class="'+(i===st.dz?'on':'')+'" data-dz="'+i+'"><span class="ph"><img src="'+px(d[1],320)+'" alt="" loading="lazy" decoding="async"></span><b>'+d[0]+'</b></button>'}).join('');
    Q('ogNDz').textContent=D.DZ[st.dz][0];
  }
  Q('ogMatH').innerHTML=(vector()?'\u0417\u043e\u0432\u043d\u0456\u0448\u043d\u0456\u0439 \u043a\u043e\u043b\u0456\u0440':'\u041a\u043e\u043b\u0456\u0440 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0443')+'<b>'+D.COL[st.mat][0]+'</b>';
  Q('ogMat').innerHTML=dotsHTML(D.COL,'mat',st.mat,false);
  Q('ogMat2Wrap').style.display=vector()?'block':'none';
  if(vector()){Q('ogMat2').innerHTML=dotsHTML(D.COL,'mat2',st.mat2,false);Q('ogNMat2').textContent=D.COL[st.mat2][0]}
  var up=(prem()?D.PREM:0);
  Q('ogSizes').innerHTML=D.SIZE.map(function(z,i){
    var ph=(prem()?'':'<span class="ph"><img src="'+px(z[3],300)+'" alt="" loading="lazy" decoding="async"></span>');
    return '<button type="button" class="'+(i===st.size?'on':'')+'" data-size="'+i+'">'+ph+'<b>'+z[0]+'</b><span class="dim">'+z[2]+'</span><span class="pr">'+money(z[1]+up)+'</span></button>'}).join('');
  Q('ogNSize').textContent=D.SIZE[st.size][0]+' \u00b7 '+D.SIZE[st.size][2];
  Q('ogLinWrap').style.display=prem()?'none':'block';
  if(!prem()){
    Q('ogLin').innerHTML=dotsHTML(D.COL,'lin',st.lin,false);
    Q('ogNLin').textContent=D.COL[st.lin][0]+(st.lin>0?' \u00b7 +'+money(D.LINPLUS):'');
    Q('ogEdge').innerHTML=dotsHTML(D.KANT,'edge',st.edge,false);
    Q('ogNEdge').textContent=D.KANT[st.edge][0];
  }
  Q('ogStWrap').style.display=prem()?'block':'none';
  if(prem()){Q('ogStitch').innerHTML=dotsHTML(D.THR,'stitch',st.stitch,true);Q('ogNSt').textContent=D.THR[st.stitch][0]}
  Q('ogEmb').className='opt'+(st.emb>0?' on':'');
  var qs=Q('ogQsel');if(qs)qs.style.display='none';
  Q('ogLogo').className='opt'+(st.logo?' on':'');
  Q('ogThrWrap').style.display=(st.emb>0?'block':'none');
  if(st.emb>0){Q('ogThr').innerHTML=dotsHTML(D.THR,'thr',st.thr,true);Q('ogNThr').textContent=D.THR[st.thr][0]}
  var fb=Q('ogFiles');
  if(st.files.length){fb.className='files on';fb.innerHTML=st.files.map(function(n){return '<div><span>'+n+'</span></div>'}).join('')}
  else{fb.className='files';fb.innerHTML=''}
  var rows='';
  rows+='<div><span>\u041e\u0440\u0433\u0430\u043d\u0430\u0439\u0437\u0435\u0440 '+CATS[st.cat][0]+' \u00b7 '+D.SIZE[st.size][0]+'</span><span>'+money(base())+'</span></div>';
  if(prem())rows+='<div><span>\u0414\u0438\u0437\u0430\u0439\u043d</span><span>'+D.DZ[st.dz][0]+'</span></div>';
  rows+='<div><span>'+(vector()?'\u0417\u043e\u0432\u043d\u0456\u0448\u043d\u0456\u0439 \u043a\u043e\u043b\u0456\u0440':'\u041a\u043e\u043b\u0456\u0440 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0443')+'</span><span>'+D.COL[st.mat][0]+'</span></div>';
  if(vector())rows+='<div><span>\u0412\u043d\u0443\u0442\u0440\u0456\u0448\u043d\u0456\u0439 \u043a\u043e\u043b\u0456\u0440</span><span>'+D.COL[st.mat2][0]+'</span></div>';
  if(!prem()){
    rows+='<div><span>\u041f\u0456\u0434\u043a\u043b\u0430\u0434\u043a\u0430</span><span>'+D.COL[st.lin][0]+'</span></div>';
    if(st.lin>0)rows+='<div><span>\u041f\u0456\u0434\u043a\u043b\u0430\u0434\u043a\u0430 \u2014 \u0434\u043e\u043f\u043b\u0430\u0442\u0430</span><span>+'+money(D.LINPLUS)+'</span></div>';
    rows+='<div><span>\u041e\u043a\u0430\u043d\u0442\u043e\u0432\u043a\u0430</span><span>'+D.KANT[st.edge][0]+'</span></div>';
  } else rows+='<div><span>\u041f\u0440\u043e\u0441\u0442\u0440\u043e\u0447\u043a\u0430</span><span>'+D.THR[st.stitch][0]+'</span></div>';
  if(st.emb>0){rows+='<div><span>\u0412\u0438\u0448\u0438\u0432\u043a\u0430</span><span>+'+money(EMBP)+'</span></div>';
    rows+='<div><span>\u041a\u043e\u043b\u0456\u0440 \u0432\u0438\u0448\u0438\u0432\u043a\u0438</span><span>'+D.THR[st.thr][0]+'</span></div>'}
  if(st.logo)rows+='<div><span>\u041c\u0435\u0442\u0430\u043b\u0435\u0432\u0435 \u043b\u043e\u0433\u043e</span><span>+'+money(D.LOGO)+'</span></div>';
  Q('ogCalc').innerHTML=rows;
  Q('ogSum').textContent=money(total());
}
function props(){
  var p={};
  p['\u0421\u0435\u0440\u0456\u044f']=CATS[st.cat][0];
  p['\u0420\u043e\u0437\u043c\u0456\u0440']=D.SIZE[st.size][0]+' ('+D.SIZE[st.size][2]+')';
  if(prem())p['\u0414\u0438\u0437\u0430\u0439\u043d']=D.DZ[st.dz][0];
  p[vector()?'\u0417\u043e\u0432\u043d\u0456\u0448\u043d\u0456\u0439 \u043a\u043e\u043b\u0456\u0440':'\u041a\u043e\u043b\u0456\u0440 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0443']=D.COL[st.mat][0];
  if(vector())p['\u0412\u043d\u0443\u0442\u0440\u0456\u0448\u043d\u0456\u0439 \u043a\u043e\u043b\u0456\u0440']=D.COL[st.mat2][0];
  if(!prem()){p['\u041f\u0456\u0434\u043a\u043b\u0430\u0434\u043a\u0430']=D.COL[st.lin][0];p['\u041e\u043a\u0430\u043d\u0442\u043e\u0432\u043a\u0430']=D.KANT[st.edge][0]}
  else p['\u041f\u0440\u043e\u0441\u0442\u0440\u043e\u0447\u043a\u0430']=D.THR[st.stitch][0];
  if(st.emb>0){p['\u0412\u0438\u0448\u0438\u0432\u043a\u0430']='\u0442\u0430\u043a';p['\u041a\u043e\u043b\u0456\u0440 \u0432\u0438\u0448\u0438\u0432\u043a\u0438']=D.THR[st.thr][0];
    var t=Q('ogTxt').value.trim();if(t)p['\u0422\u0435\u043a\u0441\u0442 \u0432\u0438\u0448\u0438\u0432\u043a\u0438']=t;
    if(st.files.length)p['\u041c\u0430\u043a\u0435\u0442']=st.files.join(', ')}
  if(st.logo)p['\u041c\u0435\u0442\u0430\u043b\u0435\u0432\u0435 \u043b\u043e\u0433\u043e']='\u0442\u0430\u043a';
  var n=Q('ogNote').value.trim();if(n)p['\u041a\u043e\u043c\u0435\u043d\u0442\u0430\u0440']=n;
  return p;
}
function msg(k,h){var m=Q('ogMsg');m.className='msg '+k;m.innerHTML=h}
function send(mode,btn){
  var pr=props(),items=[];
  items.push({id:(prem()?V.p:V.c)[st.size],quantity:1,properties:pr});
  if(!prem()&&st.lin>0)items.push({id:V.lin,quantity:1,properties:pr});
  if(st.emb>0)items.push({id:V.emb,quantity:1,properties:pr});
  if(st.logo)items.push({id:V.logo,quantity:1,properties:pr});
  if(btn)btn.disabled=true;
  msg('ok','\u0414\u043e\u0434\u0430\u0454\u043c\u043e\u2026');
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:items})})
   .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d}})})
   .then(function(res){
     if(btn)btn.disabled=false;
     if(!res.ok){msg('err','\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044c \u0434\u043e\u0434\u0430\u0442\u0438: '+((res.d&&(res.d.description||res.d.message))||''));return}
     if(mode==='buy'){location.href='/cart';return}
     msg('ok','\u0414\u043e\u0434\u0430\u043d\u043e \u0432 \u043a\u043e\u0448\u0438\u043a \u00b7 '+money(total())+' \u2014 <a href="/cart">\u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043a\u043e\u0448\u0438\u043a</a>');
   }).catch(function(){if(btn)btn.disabled=false;msg('err','\u041d\u0435\u043c\u0430\u0454 \u0437\u02bc\u0454\u0434\u043d\u0430\u043d\u043d\u044f. \u041e\u043d\u043e\u0432\u0456\u0442\u044c \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443.')});
}
document.addEventListener('click',function(e){
  var b=e.target.closest('#og [data-cat],#og [data-g],#og [data-dz],#og [data-size],#og [data-mat],#og [data-mat2],#og [data-lin],#og [data-edge],#og [data-stitch],#og [data-thr]');
  if(b){
    var y=window.scrollY,d=b.dataset;
    if(d.cat!==undefined){st.cat=+d.cat;st.g=0}
    if(d.g!==undefined)st.g=+d.g;
    if(d.dz!==undefined)st.dz=+d.dz;
    if(d.size!==undefined)st.size=+d.size;
    if(d.mat!==undefined)st.mat=+d.mat;
    if(d.mat2!==undefined)st.mat2=+d.mat2;
    if(d.lin!==undefined)st.lin=+d.lin;
    if(d.edge!==undefined)st.edge=+d.edge;
    if(d.stitch!==undefined)st.stitch=+d.stitch;
    if(d.thr!==undefined)st.thr=+d.thr;
    build();setTimeout(function(){window.scrollTo(0,y)},0);return;
  }
  if(e.target.closest('#ogEmb')){var y2=window.scrollY;
    if(st.emb>0){st.emb=0;st.files=[];var f=Q('ogFile');if(f)f.value=''}else st.emb=1;
    build();setTimeout(function(){window.scrollTo(0,y2)},0);return}
  if(e.target.closest('#ogLogo')){var y3=window.scrollY;st.logo=!st.logo;build();setTimeout(function(){window.scrollTo(0,y3)},0);return}
  var act=e.target.closest('#ogActs button');
  if(act){send(act.className==='buy'?'buy':'add',act);return}
  var a=e.target.closest('#ogNav a');
  if(a){
    var t=a.dataset.t,links=document.querySelectorAll('#ogNav a'),secs=document.querySelectorAll('#og .sec');
    for(var i=0;i<links.length;i++)links[i].className=(links[i]===a?'on':'');
    for(var j=0;j<secs.length;j++)secs[j].className='sec'+(secs[j].id==='og-'+t?' on':'');
    window.scrollTo({top:0,behavior:'smooth'});
  }
},false);
function boot(){
  if(!Q('og'))return;
  build();
  Q('ogFile').addEventListener('change',function(e){
    var list=Array.prototype.slice.call(e.target.files||[]);
    if(list.length>2)list=list.slice(0,2);
    st.files=list.map(function(f){return f.name});build();
  });
  Q('ogRev').innerHTML=D.REV.map(function(r){return '<div class="rv"><span class="st">'+stars(r[0])+'</span> <b style="font-family:\'IBM Plex Mono\',monospace;font-size:12px">'+r[0].toFixed(1)+'</b><p>'+r[1]+'</p></div>'}).join('');
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
})();
